import { computed } from 'vue';
export default function useUser() {

  const userCookie = useCookie('ft-ss-auth', { sameSite: 'none', secure: true });



  const userId = computed(() => {
    return userCookie.value?.User?.UserId;
  });

  const externalId = computed(() => {
    return userCookie.value?.externalId;
  });

  const isLoggedIn = computed(() => {
    return !!userId.value
  });

  const token = computed(() => {
    return userCookie.value?.Authentication?.AuthToken;
  });

  const jwtToken = computed(() => {
    return userCookie.value?.JwtToken;
  });

  const email = computed(() => {
    return userCookie.value?.email;
  });

  async function setAuth(payload: Object) {
    userCookie.value = payload;
  }

  async function updateAuth(payload: Object) {
    if (payload?.authToken !== undefined) {
      userCookie.value.Authentication.AuthToken = payload.authToken;
    }
    if (payload?.jwtToken !== undefined) {
      userCookie.value.JwtToken = payload.jwtToken;
    }
    if (payload?.origin !== undefined) {
      if (typeof payload.origin === 'string' && payload.origin) {
        userCookie.value.origin = payload.origin;
      } else {
        // An empty profile response cannot establish the new origin. Drop
        // the old cache entry so the next event resolves it from the record.
        delete userCookie.value.origin;
      }
    }
  }

  function getAuth() {
    return userCookie.value;
  }

  async function clearAuth() {
    userCookie.value = undefined;
    window.ftcrm = undefined;
  }

  return { userId, externalId, isLoggedIn, token, email, setAuth, updateAuth, clearAuth, getAuth, jwtToken };
}
